import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    effect,
    inject,
    signal,
    Signal,
    viewChild,
    WritableSignal,
} from "@angular/core";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { Nullable } from "@playcharge/common/models/backend/nullable";
import { ComponentRoutes } from "../../../models/constants/component-routes";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { RouterLink } from "@angular/router";
import { QuestsStore } from "../../../stores/quests/quests.store";
import { QuestViewModel } from "@playcharge/common/models/backend/quests/backoffice/quest-view-model";
import { QuestConditionType } from "@playcharge/common/models/backend/quests/quest-condition-type";
import { QuestTriggerType } from "@playcharge/common/models/backend/quests/quest-trigger-type";

@Component({
    selector: "app-quests",
    standalone: true,
    imports: [
        CommonModule,
        MatTableModule,
        MatSortModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        RouterLink,
    ],
    templateUrl: "./quests.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestsComponent {
    public questsStore: QuestsStore = inject(QuestsStore);

    public displayedColumns: WritableSignal<string[]> = signal<string[]>([
        "name",
        "triggerType",
        "conditionType",
        "isActive",
        "actions",
    ]);

    public dataSource: MatTableDataSource<QuestViewModel> =
        new MatTableDataSource<QuestViewModel>();

    private _matSort: Signal<Nullable<MatSort>> = viewChild<Nullable<MatSort>>(MatSort);

    public ComponentRoutes: typeof ComponentRoutes = ComponentRoutes;
    public QuestTriggerType: typeof QuestTriggerType = QuestTriggerType;
    public QuestConditionType: typeof QuestConditionType = QuestConditionType;

    constructor() {
        effect(() => {
            if (this._matSort()) {
                this.dataSource.sort = this._matSort()!;
            }
        });

        effect(() => {
            this.dataSource.data = this.questsStore.entities();
        });
    }

    public applyFilter(event: KeyboardEvent): void {
        this.dataSource.filter = (event.target as HTMLInputElement).value;
    }
}
